<cap-dropdown
  [formControl]="formControl"
  [hidden]="to?.readonly"
  [sortAlphabetically]="to.sortAlphabetically"
  [options]="to?.options | async"
  [optionLabel]="to?.label_key"
  [optionValue]="to?.value_key"
  [placeholder]="to?.placeholder || ' '"
  [readonly]="to?.readonly"
  [showClear]="false"
  [withImages]="!!to?.image_key"
  [filter]="true">
</cap-dropdown>
